export enum OttopilotAnnouncementsWorkspaceCapabilityAccessOperation {
    create = "4b552019-6dd0-4448-b537-eb15e99112f0",
    read = "7df6884b-31f5-4339-9f96-07ffdd216622",
    update = "99e030b6-c4ed-48c4-af16-f8fba043d6ab",
    delete = "cef579b8-9d11-47bb-b400-e87467299c64",
}
